<template>
  <div>
    <div class="mt-5 d-flex align-items-end justify-content-center" v-if="loading">
      <b-spinner variant="primary"/>
    </div>
    <div v-if="!loading">
      <vs-row vs-justify="center" v-if="mockedSteps.length">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="8">
          <step-progress
            v-if="stepList.length > 1"
            :current-step="currentStep"
            :steps="mockedSteps"
            :active-color="colors.primario"
            :active-thickness="0"
            :passive-thickness="0"
            :line-thickness="8"
          />
          <div v-if="stepList.length === 1" class="mt-5" />
        </vs-col>
      </vs-row>
      <vs-row vs-justify="center" >
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="10">
          <h4 style="color: #662583" v-if="!isConventionOrSISS && wizardData.fileNumber">
            Expediente # {{wizardData.fileNumber}}
          </h4>
          <h4 class="text-primary" v-if="isConventionOrSISS && 'dnt' in detailsFile">
              {{
                detailsFile.dnt.categoria ?
                  `Respuesta a expediente: ${titleWizardDnt}`
                :
                  `Respuesta a expediente: ${detailsFile.dnt.numeroExt}`
              }}
          </h4>
        </vs-col>
      </vs-row>
      <vs-row vs-justify="center">
        <vs-col vs-w="10">
          <vs-card id="wizard">
            <div slot="header">
              <h3>
                {{currentStepTitle}}
              </h3>
            </div>
            <div v-if="currentStepSetting">
              <component
                :company-to-load="currentCompany"
                :wizard="wizard"
                ref="step"
                :is="currentStepComponent"
                :draft="wizardData"
                :lazy="isLazyStep"
                @update-steps="updateSteps"
                @loaded="onStepLoaded"
              />
            </div>
            <div v-if="wizard.options" slot="footer" class="mt-4 pt-5">
              <vs-row vs-justify="flex-end">
                <vs-button
                  color="primary"
                  data-cy="back-button"
                  v-if="!isFirstStep"
                  @click="onBack"
                >
                  Volver
                </vs-button>
                <CheckPermission
                permission="ED014"
                v-if="wizard.options.includes('draft')"
                >
                  <vs-button
                  data-cy="save-draft-button"
                  color="primary"
                   class="ml-2"
                   @click="onBackup"
                   >
                    Guardar Borrador
                  </vs-button>
                </CheckPermission>
                <CheckPermission
                  permission="ED046"
                  v-if="wizard.options.includes('flow') && isLastStep && !isMop"
                >
                  <vs-button data-cy="send-to-flow" color="warning" class="ml-2" @click="onFlow">
                    <span>Enviar a flujo de firmas</span>
                  </vs-button>
                </CheckPermission>
                <CheckPermission
                  permission="ED046"
                  v-if="wizard.options.includes('flow') && isLastStep && isMop"
                >
                  <vs-button color="warning" class="ml-2" @click="onFlow">
                    <span>Crear expediente y generar flujo</span>
                  </vs-button>
                </CheckPermission>
                <CheckPermission permission="ED015" v-if="wizard.options.includes('submit')">
                  <vs-button data-cy="next-button" color="success" class="ml-2" @click="onNext">
                    <span v-if="isLastStep">{{ submitButtonText }}</span>
                    <span v-if="!isLastStep && wizard.displayNextTitle">
                      {{nextStepTitle}}
                    </span>
                    <span v-if="!isLastStep && !wizard.displayNextTitle">
                      Siguiente
                    </span>
                  </vs-button>
                </CheckPermission>
                <CheckPermission
                  permission="ED015"
                  v-if="wizard.options.includes('submitNumeration') && !isLastStep"
                >
                  <vs-button data-cy="next-button" color="success" class="ml-2" @click="onNext">
                    <span>Siguiente</span>
                  </vs-button>
                </CheckPermission>
              </vs-row>
            </div>
          </vs-card>
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>
<script>

import StepProgress from 'vue-step-progress';
import { mapGetters, mapActions } from 'vuex';

import config from '../config/wizard';

import CheckPermission from '@/febos/global/usuario/components/CheckPermission';
import { updateSearchParams } from '@/febos/global/utils/router';
import { AGUAS_ANDINAS, GORE_VALPARAISO, MOP } from '@/constants/companies';

export default {
  components: {
    StepProgress,
    CheckPermission
  },
  data() {
    return {
      blockButton: false,
      currentStep: Number.parseInt(this.$route.query.step || 0, 10),
      wizard: {
        steps: []
      },
      conditionData: {},
      confirmed: false,
      waitStepLoading: true
    };
  },
  computed: {
    ...mapGetters('Personalizacion', [
      'colors'
    ]),
    ...mapGetters('Empresas', [
      'company'
    ]),
    ...mapGetters('Dnts', [
      'loading',
      'wizardData',
      'detailsFile'
    ]),
    currentCompany() {
      return this.companyToLoad || this.company.iut;
    },
    titleWizardDnt() {
      return `${this.detailsFile.dnt.categoria}-${this.detailsFile.dnt.numeroExt}`;
    },
    isMop() {
      return this.company.iut === MOP.iut;
    },
    isConventionOrSISS() {
      return this.company.iut.match(/60100003-2/);
    },
    isFirstStep() {
      return this.currentStep === 0;
    },
    stepList() {
      return this.wizard.steps.filter((step) => (
        !step.condition
        || step.condition(this.conditionData)
      ));
    },
    isLastStep() {
      return this.currentStep >= this.stepList.length - 1;
    },
    isAguasAndinas() {
      return this.company.iut === AGUAS_ANDINAS.iut;
    },
    mockedSteps() {
      return new Array(this.stepList.length)
        .fill('');
    },
    currentStepSetting() {
      return this.stepList[this.currentStep];
    },
    currentStepTitle() {
      return this.currentStepSetting?.title;
    },
    currentStepComponent() {
      return this.currentStepSetting?.component;
    },
    nextStepTitle() {
      return this.stepList[this.currentStep + 1]?.title;
    },
    isLazyStep() {
      return this.currentStepSetting?.isLazy;
    },
    isLoading() {
      return this.loading || (this.isLazyStep && this.waitStepLoading);
    },
    isGore() {
      return this.company.iut === GORE_VALPARAISO.iut;
    },
    isPersonalizedWizard() {
      const { wizard } = this.$route.params;
      return wizard === 'personalizado';
    },
    submitButtonText() {
      if (this.isPersonalizedWizard) {
        return 'Continuar';
      }
      return 'Guardar y Enviar';
    }
  },
  methods: {
    ...mapActions('Dnts', [
      'clearWizardData',
      'loadWizardData',
      'addWizardData',
      'prepareWizardDataStorage',
      'setDocumentInfo',
      'mergeWizardData'
    ]),
    ...mapActions('List', [
      'fetchUserGroups'
    ]),
    onBack() {
      if (this.isFirstStep) {
        return;
      }
      this.addWizardData(this.$refs.step.getStepData());
      if (this.currentStepSetting?.draftOnBack) {
        this.mergeWizardData(this.$refs.step.getStepData());
      }

      this.currentStep -= 1;
      this.waitStepLoading = true;
    },
    async onNext() {
      try {
        if (!await this.$refs.step.isValid()) {
          return;
        }
        if (this.isLastStep) {
          this.mergeWizardData(this.$refs.step.getStepData());
          await this.onEnd();
          return;
        }

        this.addWizardData(this.$refs.step.getStepData());

        if (this.isLastStep) {
          await this.onEnd();
          return;
        }

        this.currentStep += 1;
        this.waitStepLoading = true;
        updateSearchParams({ step: this.currentStep });
        // updateSearchParams({ step: this.currentStep }); ???
      } catch (e) {
        this.blockButton = false;
        console.log('error', e);
      }
    },
    async onEnd(flow) {
      this.blockButton = true;
      const { wizard, id } = this.$route.params;
      const { query } = this.$route;
      this.$vs.loading({
        container: '#wizard',
        scale: 0.6
      });
      this.addWizardData(this.$refs.step.getStepData());
      try {
        await this.$store.dispatch(`Dnts/${this.wizard.submitAction}`, {
          id,
          data: this.wizard.documentMapper(
            this.wizardData,
            this.company.iut,
            this.company.razonSocial,
            false,
            flow
          ),
          isDraft: false,
          redirectFlow: flow,
          fromCompleteFile: query.from === 'completeFiles',
          entryExternalFile: query.from === 'entryExternalFile',
        }).then((response) => {
          this.blockButton = false;
          this.$vs.loading.close('#wizard > .con-vs-loading');
          if (this.wizard.submitAction === 'sendToFlow') {
            this.$bvToast.toast(
              'Se ha enviado a flujo exitosamente',
              {
                title: '¡Genial!',
                variant: 'primary',
                pauseOnHover: true,
                solid: true,
                noAutoHide: true
              }
            );
            const validWizards = Object.keys(config);
            if (validWizards.includes(wizard)) {
              this.wizard = config[wizard](this.company.iut);
            } else {
              console.error(`Invalid wizard: ${wizard}`);
              this.$bvToast.toast(
                'Error: Acción de asistente no válida.',
                {
                  title: 'Error',
                  variant: 'danger',
                  pauseOnHover: true,
                  solid: true,
                  noAutoHide: true
                }
              );
              return;
            }
            return;
          }
          this.setDocumentInfo({});
          const message = id ? 'Se ha actualizado el expediente ' : 'Se ha creado el expediente ';
          this.$bvToast.toast(
            `${message} #${response.data.dnt.numero}`,
            {
              title: '¡Genial!',
              variant: 'primary',
              pauseOnHover: true,
              solid: true,
              noAutoHide: true
            }
          );
          const validWizards = Object.keys(config);
          if (validWizards.includes(wizard)) {
            this.wizard = config[wizard](this.company.iut);
          } else {
            console.error(`Invalid wizard: ${wizard}`);
            this.$bvToast.toast(
              'Error: Acción de asistente no válida.',
              {
                title: 'Error',
                variant: 'danger',
                pauseOnHover: true,
                solid: true,
                noAutoHide: true
              }
            );
          }
        });
      } catch (e) {
        this.$vs.loading.close('#wizard > .con-vs-loading');
        this.blockButton = false;
        console.log('error', e);
      }
    },
    onBackup() {
      const { id } = this.$route.params;

      this.addWizardData(this.$refs.step.getStepData());

      this.$store.dispatch(`Dnts/${this.wizard.backupAction}`, {
        id,
        data: this.wizard.documentMapper(
          this.wizardData,
          this.company.iut,
          this.company.razonSocial,
          true
        ),
        isDraft: true
      }).then((response) => {
        const message = id ? 'Se ha actualizado el expediente ' : 'Se ha creado el expediente ';
        this.$bvToast.toast(
          `${message} #${response.data.dnt.numero}`,
          {
            title: '¡Genial!',
            variant: 'primary',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
      });
    },
    async onFlow() {
      if (!await this.$refs.step.isValid()) {
        return;
      }

      this.addWizardData(this.$refs.step.getStepData());
      if (this.isLastStep && this.wizard.options.includes('flow')) {
        await this.onEnd(true);
        return;
      }

      this.wizard.currentStep += 1;
      this.waitStepLoading = true;
    },
    updateSteps() {
      this.conditionData = {
        ...this.wizardData,
        ...this.$refs.step.getStepData()
      };
    },
    onStepLoaded() {
      this.waitStepLoading = false;
    }
  },
  async created() {
    this.$store.commit('Dnts/SET_LOADING', true);
    this.clearWizardData();
    const { wizard: wizarType, id } = this.$route.params;
    try {
      const configWizard = config[wizarType];
      if (configWizard) {
        this.wizard = await configWizard(this.currentCompany);
      }
      if (this.wizard.fromStorage && !id) {
        await this.prepareWizardDataStorage({
          mapper: this.wizard.wizardMapper,
        });
      }

      if (id) {
        await this.loadWizardData({
          id,
          mapper: this.wizard.wizardMapper,
          loadAllData: this.wizard.loadAllData
        });
      } else {
        this.$store.commit('Dnts/CLEAR_DETAILS');
      }
      const view = this.$route;

      if (view.name !== 'file-entry-external') {
        await this.fetchUserGroups();
      }
      this.waitStepLoading = this.isLazyStep;
    } catch (e) {
      console.log(e);
    }
    this.$store.commit('Dnts/SET_LOADING', false);
  },
  destroyed() {
    this.clearWizardData();
  },
  props: {
    companyToLoad: {
      type: String,
      required: false,
      default: null
    }
  }
};
</script>

<style lang="scss">

@import "~vue-step-progress/dist/main.css";

</style>
